module.exports = __webpack_public_path__ + "img/shipo-icon-download-2.c7de1111.svg";